// extracted by mini-css-extract-plugin
export default {"productGallery":"jG-z","inQuickShop":"kG-z"};